

export class IapData{
        subsectionName:string;     
        source:string;     
        id:string;
        subsectionId:string;  
        infoData:InfographicData;
        videoData:VideoData;
        bannerData:BannerData
        blogData: BlogData;
        textData:TextData;
    
     
        constructor() {
            this.blogData = new BlogData(); // Initialize blogData here
            this.bannerData = new BannerData();
            this.videoData = new VideoData()
            this.infoData = new InfographicData()
            this.textData = new TextData()
        }
    
    }

    export class InfographicData{
        thumbnailPath:string ='';
        filePath:string = ''
    }
    
    export class VideoData{
        title:string = '';
        youtubeLink:string='';
        imagePath:string ='';
    }

    export class BannerData {
        bannerImage:string = '';
        clickableUrl:string= '';
        sequence:string= '';
        mobbannerImage:string= '';
        mobileBannerImagePath:string= '';
        webBannerImagePath:string= '';
    }

    export class BlogData {
        content: string = '';
        title: string = '';
        imagePath: string = '';
        id: string = '';
        similarArticles :any[] = []
    }

    export interface Blog {
        id: number;
        title: string;
      }

      export class Card {
        id:string='';
        title: string = '';
        description: string = '';
        icon: File ; // Path or identifier for the card icon
        iconPath: string = ''; // File name for uploaded image
        sequence:string=''
      }
    export class TextData {
        description: string = '';
        title: string = '';
        id: string = '';
        sectionId: string = '';
        sectionName: string = '';
        mobile:string = '';
        email:string='';
        disclaimerAdditionalText:string=''
        subSections: Card[] = []; // New property for multiple subSections
      
        constructor() {
            // Initialize with three default subSections
            this.subSections = [
              new Card(),
              new Card(),
              new Card()
            ];
          }
    }